import { Controller } from "@hotwired/stimulus";
import CryptoJS from "crypto-js";
import flash from "../lib/flashes.js"

export default class extends Controller {
  static targets = ["visibleNote", "encryptedNote", "visibleLabel", "encryptedLabel", "formSection", "successSection", "shareUrl"]

  connect() {
    this.encryptionKey = this.generateKey();
  }

  encryptNote() {
    const plaintext = this.visibleNoteTarget.value;
    if (plaintext) {
      this.encryptedNoteTarget.value = CryptoJS.AES.encrypt(plaintext, this.encryptionKey).toString();
    } else {
      this.encryptedNoteTarget.value = "";
    }
  }

  encryptLabel() {
    if (!this.hasVisibleLabelTarget || !this.hasEncryptedLabelTarget) return;

    const labelPlaintext = this.visibleLabelTarget.value;
    if (labelPlaintext) {
      this.encryptedLabelTarget.value = CryptoJS.AES.encrypt(labelPlaintext, this.encryptionKey).toString();
    } else {
      this.encryptedLabelTarget.value = "";
    }
  }

  // Helper method to generate random encryption key
  generateKey(length = 40) {
    const array = new Uint8Array(length / 2);
    window.crypto.getRandomValues(array);
    return Array.from(array, this.dec2hex).join('');
  }

  // Helper method for hex conversion
  dec2hex(dec) {
    return dec.toString(16).padStart(2, "0");
  }

  async onSubmit(event) {
    event.preventDefault()

    if (!this.visibleNoteTarget.value.trim()) {
      this.visibleNoteTarget.focus()
      flash("Please enter a note", "error")
      return
    }

    this.encryptNote()
    this.encryptLabel()

    const form = event.target
    const formData = new FormData(form)

    try {
      const response = await fetch(form.action, {
        method: form.method,
        body: formData,
        headers: {
          "Accept": "application/json"
        }
      })

      const data = await response.json()

      if (response.ok) {
        this.formSectionTarget.style.display = "none"
        this.successSectionTarget.style.display = "flex"

        const shareUrl = `${data.url}?key=${this.encryptionKey}`
        this.shareUrlTarget.value = shareUrl
      }
    } catch (error) {
      console.error("Error creating secure note:", error)
    }
  }

  copyLink() {
    this.shareUrlTarget.select()
    document.execCommand('copy')
    flash("Copied", "success")
  }

  reset() {
    const form = this.formSectionTarget.querySelector('form')

    const expirationSelect = form.querySelector('select[name="secure_note[expiration_date]"]')
    const firstViewCheckbox = form.querySelector('input[name="secure_note[first_view]"][type="checkbox"]')
    const savedExpiration = expirationSelect.value
    const savedFirstView = firstViewCheckbox.checked


    form.reset()

    expirationSelect.value = savedExpiration
    firstViewCheckbox.checked = savedFirstView

    this.encryptedNoteTarget.value = ''
    this.visibleNoteTarget.value = ''

    if (this.hasEncryptedLabelTarget) this.encryptedLabelTarget.value = ''
    if (this.hasVisibleLabelTarget) this.visibleLabelTarget.value = ''

    this.shareUrlTarget.value = ''

    // Reset display states
    this.formSectionTarget.style.display = "block"
    this.successSectionTarget.style.display = "none"

    // Generate new encryption key
    this.encryptionKey = this.generateKey()

    // Re-enable the submit button
    const submitButton = form.querySelector('input[type="submit"]')
    if (submitButton) {
      submitButton.disabled = false
    }
  }
}
